import styled, { keyframes } from 'styled-components'
import { Arrow, Content } from '@radix-ui/react-popover'

const slideUpAndFade = keyframes`
  from {
    opacity: 0;
    transform: translateY(2px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

const slideRightAndFade = keyframes`
  from {
    opacity: 0;
    transform: translateX(-2px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`

const slideDownAndFade = keyframes`
  from {
    opacity: 0;
    transform: translateY(-2px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

const slideLeftAndFade = keyframes`
  from {
    opacity: 0;
    transform: translateX(2px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`

export const StyledContent = styled(Content)`
  border-radius: 0.4rem;
  background-color: ${({ theme }) => theme.colors.modalBackground};
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.28);
  animation-duration: 400ms;
  animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
  will-change: transform, opacity;
  max-width: 30rem;

  &[data-state='delayed-open'][data-side='top'] {
    animation-name: ${slideDownAndFade};
  }

  &[data-state='delayed-open'][data-side='right'] {
    animation-name: ${slideLeftAndFade};
  }
  &[data-state='delayed-open'][data-side='bottom'] {
    animation-name: ${slideUpAndFade};
  }
  &[data-state='delayed-open'][data-side='left'] {
    animation-name: ${slideRightAndFade};
  }
`

export const TextContent = styled.div`
  overflow-y: auto;
  max-height: var(--radix-popover-content-available-height);
  padding: 1rem 1.5rem;
`

export const StyledArrow = styled(Arrow)`
  fill: ${({ theme }) => theme.colors.modalBackground};
  width: 3rem;
  height: 1.5rem;
`
